import React, { useRef, useEffect, useState, forwardRef } from 'react';
import ScrollbarDynamic from '../scrollbar/ScrollbarDynamic';
import { border } from '../styles';

// eslint-disable-next-line react/display-name
const ScrollbarRow = forwardRef(
    (
        {
            stickyColCount = 0,
            colCount,
            onScroll,
            tableWidth,
            containerWidth,
            tableOffset = 0,
            scrollPxH = 0,
            scrollPxV = 0,
            ...props
        },
        ref
    ) => {
        const gutterRef = useRef(null);
        const [stickyRowOffset, setStickyRowOffset] = useState(0);
        useEffect(() => {
            setStickyRowOffset(gutterRef?.current?.offsetLeft - tableOffset);
        }, [gutterRef?.current?.offsetLeft]);

        const maxVisibleLength = containerWidth - stickyRowOffset;

        const headerStyle = {
            padding: 0,
            backgroundColor: '#ffffff',
            position: 'relative',
            bottom: scrollPxV,
            zIndex: 200,
            borderRight: border
        };

        return (
            <tr ref={ref} {...props}>
                {stickyColCount > 0 && (
                    <th
                        id='sticky-column-header-no-scrollbar'
                        colSpan={stickyColCount}
                        style={headerStyle}
                    />
                )}
                <th
                    id='sticky-column-header-scrollbar'
                    ref={gutterRef}
                    colSpan={colCount}
                    style={headerStyle}
                >
                    <div
                        id='as-grid-horizontal-scrollbar-gutter'
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            boxSizing: 'border-box',
                            height: 20,
                            backgroundColor: '#d8d8d8',
                            width: maxVisibleLength + 1
                        }}
                    >
                        <ScrollbarDynamic
                            scrollPx={scrollPxH}
                            onScroll={onScroll}
                            scrollableLength={tableWidth - stickyRowOffset - 1}
                            maxVisibleLength={maxVisibleLength}
                            isHorizontal
                            gutterOffset={stickyRowOffset + tableOffset}
                        />
                    </div>
                </th>
            </tr>
        );
    }
);

export default ScrollbarRow;
